import api from './axios.js';

export const voiceApi = {
  token: () => api.post('/voice/token'),
  transfer: (data) => api.post('/voice/transfer', data),
};
